import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, buttonClasses } from '@/components/ui';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-meradio-primary/10 to-meradio-secondary/10 dark:from-meradio-primary/5 dark:to-meradio-secondary/5 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold gradient-text mb-2">404</h1>
          <h2 className="text-2xl font-bold text-meradio-dark dark:text-meradio-cream mb-4">
            Page Not Found
          </h2>
          <p className="text-meradio-dark-light dark:text-meradio-dark-light">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={() => navigate(-1)} variant="outline">
            Go Back
          </Button>
          <Link
            to="/"
            className={`${buttonClasses('primary')} inline-block`}
          >
            Go Home
          </Link>
        </div>

        <div className="mt-8">
          <p className="text-sm text-meradio-dark-light dark:text-meradio-dark-light">
            Need help?{' '}
            <a
              href="mailto:support@meradio.com"
              className="text-meradio-primary hover:text-meradio-primary-dark dark:hover:text-meradio-primary transition-colors underline"
            >
              Contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
